import { Table } from 'reactstrap';
import { ISearchPositionResult } from '../../../types/position';
import { fullNameAutoFormat } from '../../../utils/format-fullname';
import PaginationBar from '../../common/pagination-bar';
import { useEffect, useState } from 'react';
import './search-position-role.scss'
import OmsToolTip from "../../common/oms-tooltip/oms-tooltip";
import { Pageable } from '../../../types/common';
import TableHeaders, { TableHeaderInfo } from '../../common/table-header';
import { phoneNumberAutoFormat2 } from '../../../utils/format-phone';
import { FaRegCircleXmark } from 'react-icons/fa6';
import useAuth from '../../../hook/useAuth';
import Button from '../../common/button';

interface SearchPositionRoleResultProp extends Pageable<ISearchPositionResult> {
    selected: any | undefined;
    onTitleSelect: (item:ISearchPositionResult) => void;
    onIndividualSelect: (item:ISearchPositionResult) => void;
    inputChanged: boolean;
    isInputError: boolean;
}

const TABLE_HEADERS: TableHeaderInfo<ISearchPositionResult>[] = [
    { header: "Position/Role", accessor: "positionId", sortable: true },
    { header: "Title", accessor: "title", sortable: true, presorted: 'asc' },
    { header: "Individual Name", accessor: "individualFirstName", sortable: true },
    { header: "Position Phone/Fax", accessor: "phoneFaxes", sortable: true, cssClass: "phone-column" },
    { header: "Position Email", accessor: "emails", sortable: true },
];

function SearchPositionRoleResult (props:SearchPositionRoleResultProp) {
    const { data:records,pageSize=10, selected, onTitleSelect, onIndividualSelect, inputChanged ,isInputError} = props;

    const [sortedData, setSortedData] = useState<ISearchPositionResult[]>([]);
    const [pagedData, setPagedData] = useState<ISearchPositionResult[]>([]);
    const { isAdmin  } = useAuth();

    return (
        <>
            <Table id="positions_table" striped className="fixed">
                <caption className="sr-only">Search results, sortable</caption>
                <TableHeaders headers={TABLE_HEADERS} sortableData={records} onSort={setSortedData} />

                <tbody>
                    {sortedData.length>0
                        ? pagedData.map((record, index) => {
                            return <tr key={record.positionId+'-'+index}>
                                <td>{(record.role?'Role':'Position')}{ record.assignmentType?(' ('+record.assignmentType+')'):''}</td>
                                <td>
                                    <Button color="link"
                                        className={`oms-button-link ${selected === searchPositionRoleSelectedTitle(record) ? 'oms-button-link-selected' : '' }`}
                                        id={`${record.positionId}-${index}-title`}
                                        onClick={()=>{onTitleSelect(record)}}>
                                            <OmsToolTip positionId={record.positionId}>
                                                    {record.title}
                                            </OmsToolTip>

                                    </Button>
                                    <span> {isAdmin && (!record.active && <FaRegCircleXmark/>)}</span>
                                </td>
                                <td>
                                    <Button color="link"
                                        className={`oms-button-link ${selected === searchPositionRoleSelectedIndividual(record) ? 'oms-button-link-selected' : '' }`}
                                        id={`${record.individualId}-${index}-individual`}
                                        onClick={()=>{onIndividualSelect(record)}}>
                                        {record.individualId?fullNameAutoFormat(record.individualFirstName,record.individualMiddleName,record.individualLastName):''}
                                    </Button>

                                </td>
                                <td>
                                    {record.phoneFaxes && record.phoneFaxes.map((phone,i) => (
                                        <div key={phone.id+"-"+i}>{phoneNumberAutoFormat2("",phone.areaCode,phone.localNumber,phone.extension)}</div>
                                    ))}
                                </td>
                                <td>
                                    {record.emails && record.emails.map((email,i) => (
                                        <div key={email.id+"-"+i}>{email.emailAddressTxt}</div>
                                    ))}
                                </td>
                            </tr>
                        })
                        :<tr><td colSpan={TABLE_HEADERS.length} className="text-center">{inputChanged?(isInputError ? 'No results found.' : 'Search results will appear in the table.'):'No position/role titles were found with the exact search match.'}</td></tr>
                    }
                </tbody>
            </Table>

            <PaginationBar data={sortedData} pageSize={pageSize} onPageChange={setPagedData} />
        </>
    )
}

export function searchPositionRoleSelectedIndividual(record: ISearchPositionResult) : string {
    return `search-position-role-selected-individual-${record.individualId ?? 0}-${record.positionId}`;
}

export function searchPositionRoleSelectedTitle(record: ISearchPositionResult) : string {
    // individualId should never be null in this case, but better to be safe
    return `search-position-role-selected-title-${record.individualId ?? 0}-${record.positionId}`;
}

export default SearchPositionRoleResult
